import { useCallback, useContext } from 'react'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import { useLuxPlusMonthOfferState } from '../hooks/useLuxPlusMonthOfferState'
import LuxPlusMonthTakeoverDetailsModal from './LuxPlusMonthTakeoverDetailsModal'

interface Props {
  offer: App.AnyOffer
}

function LuxPlusMonthOfferPageNotice({ offer }: Props) {
  const showModal = useContext(ModalContext)
  const { showsCampaignTag, requiresLuxPlusAccess, membershipRequired } = useLuxPlusMonthOfferState(offer)
  const openModal = useCallback(() => {
    showModal(<LuxPlusMonthTakeoverDetailsModal offer={offer} onOfferPage />)
  }, [showModal, offer])

  if (!showsCampaignTag || !requiresLuxPlusAccess) {
    return null
  }

  const link = (chunks: ReactNode) => <TextLink colour="lux-plus" weight="regular" onClick={openModal}>{chunks}</TextLink>

  return <BodyText variant="medium" weight="bold" colour="lux-plus">
    {membershipRequired && <FormattedMessage
      id="VN2LUcjUJrw6FzkoOtA9"
      defaultMessage="Join LuxPlus+ to access this exclusive member offer. <link>Learn more</link>"
      description="Notice shown next to the LuxPlus+ Month campaign tag on the offer page, prompting non-members to join LuxPlus+"
      values={{ link }}
    />}
    {!membershipRequired && <FormattedMessage
      id="al_2eVdj0OMlr2zmp8H0"
      defaultMessage="Enjoy exclusive access to this member-only offer. <link>Learn more</link>"
      description="Notice shown next to the LuxPlus+ Month campaign tag on the offer page for members who can already access this member-only offer"
      values={{ link }}
    />}
  </BodyText>
}

export default LuxPlusMonthOfferPageNotice
